import { Component, OnInit } from '@angular/core';
import { DashboardWrapperComponent } from '../../components/dashboard-wrapper/dashboard-wrapper.component';
import { LoaderComponent } from 'app/components/loader/loader.component';
import { TranslateModule } from '@ngx-translate/core';
import { Jc3feedbackService } from './jc3feedback.service';
import { CommonModule } from '@angular/common';
import { PdfService } from 'app/services/pdf.service';

@Component({
    selector: 'app-jc3-feedback-form',
    standalone: true,
    imports: [
        DashboardWrapperComponent,
        LoaderComponent,
        TranslateModule,
        CommonModule,
    ],
    templateUrl: './jc3-feedback-form.component.html',
    styleUrl: './jc3-feedback-form.component.scss',
})
export class Jc3FeedbackFormComponent implements OnInit {
    isLoading: boolean = false;
    constructor(
        private _feedbackService: Jc3feedbackService,
        private _pdfService: PdfService,
    ) {}
    feedbacks = [];

    ngOnInit(): void {
        this.isLoading = true;

        this._feedbackService.fetchFeedbackList().subscribe({
            next: (data) => {
                this.isLoading = false;
                if (data?.feedbacks?.length > 0) {
                    this.feedbacks = data?.feedbacks;
                } else {
                    this.feedbacks = [];
                }
            },
            error: (err) => {
                console.error(err);
                this.isLoading = false;
            },
            complete: () => {
                this.isLoading = false;
            },
        });
    }

    downloadInfo() {
        this._pdfService.downloadFeedbackReport(this.feedbacks);
    }
}
